import { useTheme } from '../contexts/ThemeContext';

export default function RefreshButton({ onClick, title = "Atualizar dados" }) {
  const { darkMode } = useTheme();

  return (
    <button
      onClick={onClick}
      className={`px-4 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2 transition-all hover:-translate-y-0.5 ${darkMode
        ? 'bg-slate-700/50 border border-slate-600/50 text-slate-300 hover:bg-slate-700'
        : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 shadow-sm'
      }`}
      title={title}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
      Atualizar
    </button>
  );
}
